module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-500-4d88404f733741eaacfda2e318840a98.ttf";